import Vue from 'vue'
import Router from 'vue-router'

// 登录页面
const LoginIndex = () => import(/* webpackChunkName: "LoginIndex" */ '@/view/login/Index')
const ProjectFrame = () => import(/* webpackChunkName: "ProjectFrame" */ '@/view/ProjectFrame/Index')
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }
Vue.use(Router)
// export default new Router({
//   // mode: 'history', //后端支持可开
//   scrollBehavior: () => ({
//     y: 0
//   }),
//   routes: [{
//     path: '/login',
//     name: 'LoginIndex',
//     component: LoginIndex,
//     meta: {
//       notrequireAuth: true
//     }
//   }]
// })

export let routes = [{
  path: '/login',
  name: 'LoginIndex',
  component: LoginIndex,
  meta: {
    notrequireAuth: true
  }
},
{
  path: '/',
  name: 'ProjectFrame',
  component: ProjectFrame,
  meta: {
    notrequireAuth: false
  }
},
{
  path: '/404',
  component: () => import('@/view/404'),
  meta: {
    notrequireAuth: true
  },
  hidden: true
}
]
const createRouter = () => new Router({
  routes: routes
})
const router = createRouter()
// 写一个重置路由的方法，切换用户后，或者退出时清除动态加载的路由
// 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}
export {router}



// WEBPACK FOOTER //
// ./src/router/index.js